<div class="topHead">
    <h2>Course Management</h2>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="pageTitleBox">
        <h2>Course Management</h2> 
    </div>
    <div class="adminTabWrap">
        <div class="filterWrap courseFiltr">
            <div class="searchWrap mr-5">
                <input type="text" placeholder="Search by Course Name" (keyup)="search($event)" />
            </div>
            <a href="javascript:void(0);" [routerLink]="['/courses_create']" class="btn btn-primary btn-sm createBtn">+
                Create New Course</a>
        </div>
        <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="onSelectChange($event)">
            <mat-tab label="Active" (click)="courseList('',1)">
                <div class="tableWrap">

                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="course_name"><b></b> Course Name</div>
                                </th>
                                <th>
                                    <div mat-sort-header="end_date"><b></b>End Date</div>
                                </th>
                                <th>Created By</th>
                                <th>Module /<br />
                                    Submodule</th>
                                <th>Assessments</th>
                                <th>Assigned<br/>To (Users)</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let values of courseListData; let i = index">
                                <td>
                                    <div class="userTdWrap">
                                        <a href="javascript:void(0);" class="btn-link" [routerLink]="['/courses_view_courses']"
                                        [queryParams]="{courseId:values.course_id}" [ngbTooltip]="values?.course_name | wordCountTooltip: 3">
                                        {{values?.course_name}}
                                      </a>
                                        <b>Modified on {{values?.modified_dttm}}</b>
                                    </div>
                                </td>
                                <td>
                                    <div class="expireDate">
                                        {{values?.end_date}} 
                                    </div>
                                    <a href="javascript:void(0);" (click)="open0(content02,values.course_id)" class="btn-link">EXTEND</a>
                                    <span *ngIf="cousreEndDate(values.end_date) > 0.9">Course Ended</span>
                                </td>
                                <td>{{values?.created_by}}</td>
                                <td>{{values?.module_count}} /{{values?.sub_module_count}}</td>
                                <td>{{values?.total_assessments}}</td>
                                <td>{{values?.assigned_users_count}}</td>
                                <td>
                                    <ul class="userActionBtn">
                                        <li *ngIf="values.assigned_users_count == 0 && cousreEndDate(values.end_date) <= 0"><a href="javascript:void(0);" class="btn-link"
                                             [routerLink]="['/courses_create']"
                                            [queryParams]="{Id:values.course_id,type:'edit'}">EDIT</a></li>
                                        <li *ngIf="values.assigned_users_count == 0"> <a href="javascript:void(0);" class="btn-link"
                                            [routerLink]="['/courses_view_courses']"
                                            [queryParams]="{courseId:values.course_id,tab:2}">PREVIEW</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link"
                                                [routerLink]="['/courses_view_user']"
                                                [queryParams]="{courseId:values.course_id}">VIEW USERS</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link"
                                                [routerLink]="['/courses_assign_users']"
                                                [queryParams]="{courseId:values.course_id,tab:1}">ASSIGN USERS</a></li>
                                        <li ><a href="javascript:void(0);"  class="btn-link"  (click)="open(duplicate,values.course_id,'Active')">DUPLICATE</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link second-link"
                                                (click)="open(deactivate,values.course_id,'Active')" >DEACTIVATE</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link second-link"
                                                    (click)="open(delete,values.course_id,'Active')">DELETE</a></li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </mat-tab>
            <mat-tab label="Deactivated" (click)="courseList('',0)">
                <div class="tableWrap">
                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="course_name"><b></b> Course Name</div>
                                </th>
                                <th>
                                    <div mat-sort-header="end_date"><b></b>End Date</div>
                                </th>
                                <th>Created By</th>
                                <th>Module /<br />
                                    Submodule</th>
                                <th>Assessments</th>
                                <th>Assigned<br/>To (Users)</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let values of courseListData; let i = index">
                                <td>
                                    <div class="userTdWrap">
                                        <a href="javascript:void(0);" class="btn-link"
                                            [routerLink]="['/courses_view_courses']"
                                            [queryParams]="{courseId:values.course_id,tab:1}">{{values?.course_name}}</a>
                                        <b>Modified on {{values?.modified_dttm}}</b>
                                    </div>
                                </td>
                                <td>
                                    <div class="expireDate">
                                        {{values?.end_date}}
                                        <!-- <a href="javascript:void(0);" class="btn-link">EXTEND</a> -->
                                    </div>
                                    <a href="javascript:void(0);" (click)="open0(content02,values.course_id)" class="btn-link">EXTEND</a>
                                    <span *ngIf="cousreEndDate(values.end_date) > 0">Course Ended</span>
                                </td>
                                <td>{{values?.created_by}}</td>
                                <td>{{values?.module_count}} /{{values?.sub_module_count}}</td>
                                <td>{{values?.total_assessments}}</td>
                                <td>{{values?.assigned_users_count}}</td>
                                <td>
                                    <ul class="userActionBtn">
                                        <!-- <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/courses_view_user']" [queryParams]="{courseId:values.course_id}">VIEW COURSES</a></li> -->
                                        <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/courses_view_user']"
                                            [queryParams]="{courseId:values.course_id,tab:1}">VIEW USERS</a></li>
                                        <li ><a href="javascript:void(0);" class="btn-link" (click)="open(duplicate,values.course_id,'Deactivated')">DUPLICATE</a></li>
                                        <li><a href="javascript:void();"
                                                (click)="open(active,values.course_id,'Deactivated')"
                                                class="btn-link-green">ACTIVATE</a></li>
                                       <li><a href="javascript:void(0);" class="btn-link second-link"
                                                    (click)="open(delete,values.course_id,'Deactivated')">DELETE</a></li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </mat-tab>
            <mat-tab label="DRAFT" (click)="courseList('',2)">
                
                <div class="tableWrap">
                    <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                        <thead>
                            <tr>
                                <th>
                                    <div mat-sort-header="course_name"><b></b> Course Name</div>
                                </th>
                                <th>Created By</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="selectTr" *ngFor="let values of courseListData; let i = index">
                                <td>
                                    <div class="userTdWrap">
                                        <a href="javascript:void(0);" class="btn-link"
                                            [routerLink]="['/courses_create']"
                                            [queryParams]="{Id:values.course_id,tab:2}">{{values?.course_name}}</a>
                                        <b>Modified on {{values?.modified_dttm}}</b>
                                    </div>
                                </td>
                                <td>
                                    {{values?.created_by}}
                                </td>
                                <td>
                                    <ul class="userActionBtn">
                                        <li  class="w-auto" ><a href="javascript:void(0);" class="btn-link"
                                                [routerLink]="['/courses_view_courses']"
                                                [queryParams]="{courseId:values.course_id,tab:2}">PREVIEW</a></li>
                                        <li  class="w-auto" ><a href="javascript:void(0);" class="btn-link" (click)="open(duplicate,values.course_id,'Draft')">DUPLICATE</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link"
                                                (click)="open(publish,values.course_id,'DRAFT')">PUBLISH</a></li>
                                        <li><a href="javascript:void(0);" class="btn-link second-link"
                                                (click)="open(delete,values.course_id,'DRAFT')">DELETE</a></li>
                                                
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </mat-tab>
        </mat-tab-group>

    </div>

</div>

<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate course</h6>
                <p class="size18">Are you sure you want to deactivate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(course_id,0)">Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate course</h6>
                <p class="size18">Are you sure you want to duplicate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="duplicateCapsule(course_id,tabName)">Yes, Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>
<!-- <ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
              <div *ngIf="activeCourse">
                <h6>Activate Course</h6>
                <p class="size18">Please add an end date for the course to activate it.</p>
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Choose a date</mat-label>
                        <input matInput [matDatepicker]="picker" placeholder="Select Date">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="successClick()" class="btn btn-primary btn-sm">Activate course</a>
            </div>

            <div *ngIf="succesCourse">
               <figure><img src="assets/images/admin/circle_check.png" /></figure>
                <p class="size18">You have successfully activated the course.<br/>
                    You can now assign users!</p>
                <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.dismiss('Cross click')">Close</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="modal.dismiss('Cross click')">Assign Users now</a>
            </div>
 
        </div>
    </div>
  </ng-template> -->
<ng-template #publish let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Publish course</h6>
                <p class="size18">Are you sure you want to publish this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="coursePublised(course_id)">Yes,
                    Publish</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #active let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate course</h6>
                <p class="size18">Are you sure you want to activate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsActiveVal(course_id,1)">Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #delete let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Delete course</h6>
                <p class="size18">Are you sure you want to delete this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="deleteCourse(course_id)">Yes,
                    Delete</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #content02 let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <form [formGroup]="extendForm">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
              <div *ngIf="activeCourse">
                <h6>Extend </h6>
                <p class="size18">Select a date to extend the end date of the course.</p>
                <div class="commanInput commanDate">
                    <mat-form-field class="example-full-width" (click)="picker.open()">
                        <mat-label>Choose a date</mat-label>
                        <input matInput [min]="minDate"  formControlName="endDate" [matDatepicker]="picker" placeholder="Select Date" [readonly]=true>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                   
                </div>
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="successExtendDate()"  class="btn btn-primary btn-sm">Extend Course</a>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
               
            </div>
            <div *ngIf="succesCourse">
               <figure><img src="assets/images/admin/circle_check.png" /></figure>
                <p class="size18">You have successfully Extend.<br/></p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <!-- <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.dismiss('Cross click')">Close</a> -->
                <a href="javascript:void(0);" (click)="successDate();modal.dismiss('Cross click')"  class="btn btn-primary btn-sm">Close</a>
            </div>
        </form>
        </div>
    </div>
  </ng-template>